import React from 'react'
import useGetHook from '../../customHooks/useGetHook';
import APIS from '../../constant/EndPoint';
import loadable from '@loadable/component';

const RiderDashboardComponent = loadable(
  () => import("../../components/RiderDashboard")
);

const RiderDashboard = () => {
  const { data: riderStatus } = useGetHook({
    queryKey: [`rider-stats`],
    url: `${APIS.GRID_REPORT}rider-overview/`,
    params: {
    },
  });
  return (
    <>
      <RiderDashboardComponent
        status={riderStatus}
      />
    </>
  )
}

export default RiderDashboard
